import React from "react";
import "./footer.css";
const Footer = () => {
  return (
    <div className="md:flex static bottom-0 right-0 left-0 justify-between footer items-center	px-4 sm:px-24">
      <div className="p-3 md:flex items-center text-[#ffffff] opacity-70	">
        <p>
          © 2022{" "}
          <span className="font-semibold" style={{ color: "white" }}>
            Premint, Inc
          </span>
        </p>
        <hr className="md:hidden block my-2" />
        <ul className="md:flex md:mx-2 footer-navigation ">
          <li>Copyright</li>
          <li>Terms</li>
          <li>Privacy Policy</li>
        </ul>
      </div>
      <div>
        <ul className="flex socials">
          <li>
            <i class="fa-brands fa-linkedin-in"></i>
          </li>
          <li>
            <i class="fa-brands fa-facebook-f"></i>
          </li>
          <li>
            <i class="fa-brands fa-twitter"></i>
          </li>
          <li>
            <i class="fa-brands fa-pinterest-p"></i>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
